"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const WebpSupportHelper_1 = __importDefault(require("@react/web/Common/WebpSupportHelper/WebpSupportHelper"));
const CarListingOfferListItemView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/CarListingOfferListItemView"));
const MergedCarListingOfferListItemView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/MergedCarListingOfferListItemView"));
const CarListingOfferListItemView_2 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/mobile/CarListingOfferListItemView"));
const MergedCarListingOfferListItemView_2 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/mobile/MergedCarListingOfferListItemView"));
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
const formatContractLength = (contractLength) => {
    if (contractLength.length === 0) {
        return null;
    }
    const sorted = contractLength.sort((a, b) => a - b);
    const label = NumberFormatter_1.default.getMonthsLabel(Number(sorted[sorted.length - 1]));
    return `${sorted.join(', ')} ${label}`;
};
const formatMileage = (mileage) => {
    if (mileage.length === 0) {
        return null;
    }
    const minMileage = Math.min(...mileage);
    const maxMileage = Math.max(...mileage);
    if (mileage.length === 1) {
        return `${NumberFormatter_1.default.formatMileage(minMileage)}`;
    }
    return `${NumberFormatter_1.default.formatMileage(minMileage)} - ${NumberFormatter_1.default.formatMileage(maxMileage)}`;
};
class CarListingOfferListItemComponent extends react_1.Component {
    constructor(props) {
        super(props);
        this.imgElementRef = react_1.default.createRef();
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidUpdate() {
        const imgElement = this.imgElementRef.current;
        imgElement.removeAttribute('data-image-status');
    }
    render() {
        if (this.props.showMergedOffer === true) {
            if (this.props.isSmallScreen === false) {
                return (0, MergedCarListingOfferListItemView_1.default)({
                    handleClick: this.handleClick,
                    isWebpSupported: (0, WebpSupportHelper_1.default)(),
                    listingOffer: this.props.listingOffer,
                    simpleOffer: this.props.simpleOffer,
                    imgElementRef: this.imgElementRef,
                    isListingOffersListEmpty: this.props.isListingOffersListEmpty,
                    isActiveContractLengthFilter: this.props.isActiveContractLengthFilter,
                    contractLengths: this.getPriceOfferMileageContractLength().contractLength,
                    mileage: this.getPriceOfferMileageContractLength().mileage,
                });
            }
            return (0, MergedCarListingOfferListItemView_2.default)({
                handleClick: this.handleClick,
                isWebpSupported: (0, WebpSupportHelper_1.default)(),
                listingOffer: this.props.listingOffer,
                simpleOffer: this.props.simpleOffer,
                imgElementRef: this.imgElementRef,
                isListingOffersListEmpty: this.props.isListingOffersListEmpty,
                isActiveContractLengthFilter: this.props.isActiveContractLengthFilter,
                contractLengths: this.getPriceOfferMileageContractLength().contractLength,
                mileage: this.getPriceOfferMileageContractLength().mileage,
            });
        }
        if (this.props.isSmallScreen === false) {
            return (0, CarListingOfferListItemView_1.default)({
                isWebpSupported: (0, WebpSupportHelper_1.default)(),
                listingOffer: this.props.listingOffer,
                simpleOffer: this.props.simpleOffer,
                filterCount: this.props.filterCount,
                imgElementRef: this.imgElementRef,
                isActiveContractLengthFilter: this.props.isActiveContractLengthFilter,
                contractLengths: this.getPriceOfferMileageContractLength().contractLength,
                mileage: this.getPriceOfferMileageContractLength().mileage,
            });
        }
        return (0, CarListingOfferListItemView_2.default)({
            isWebpSupported: (0, WebpSupportHelper_1.default)(),
            listingOffer: this.props.listingOffer,
            simpleOffer: this.props.simpleOffer,
            filterCount: this.props.filterCount,
            imgElementRef: this.imgElementRef,
            isActiveContractLengthFilter: this.props.isActiveContractLengthFilter,
            contractLengths: this.getPriceOfferMileageContractLength().contractLength,
            mileage: this.getPriceOfferMileageContractLength().mileage,
        });
    }
    handleClick(listingOffer, isListingOffersListEmpty) {
        this.props.handleClick(listingOffer, isListingOffersListEmpty);
    }
    getPriceOfferMileageContractLength() {
        const mileageArr = [];
        const contractLengthArr = [];
        const pushValueToArray = (priceOffers) => {
            priceOffers.forEach((priceOffer) => {
                if (mileageArr.includes(priceOffer.mileageYearly) === true) {
                    return;
                }
                mileageArr.push(priceOffer.mileageYearly);
                if (priceOffer.contractLengths === null) {
                    return;
                }
                priceOffer.contractLengths.forEach((contractLength) => {
                    if (contractLengthArr.includes(contractLength.value) === true) {
                        return;
                    }
                    contractLengthArr.push(contractLength.value);
                });
            });
        };
        if (this.props.showMergedOffer) {
            this.props.listingOffer.simpleOfferList.simpleOffers.forEach((offer) => {
                pushValueToArray(offer.priceOfferList.priceOffers);
            });
        }
        else {
            pushValueToArray(this.props.simpleOffer.priceOfferList.priceOffers);
        }
        return {
            contractLength: formatContractLength(contractLengthArr),
            mileage: formatMileage(mileageArr),
        };
    }
}
exports.default = CarListingOfferListItemComponent;
